// extracted by mini-css-extract-plugin
module.exports = {"banner-search":"BannerSearch_banner-search__Sz06q"};